import $ from "jquery";
import Cookies from "js-cookie";
import TrapFocus from "./focusTrap";

const BannerIce = (el) => {
    const $el = $(el);
    const $banner = $(".banner-ice");
    const $bannerOpenButton = $(".banner-ice-notice__button");
    const $bannerContentLinks = $banner.find("a");

    if (!$banner.hasClass("banner-ice--closed")) {
        $("body").addClass("no-scroll");
        $el.attr("aria-expanded", "true");

        TrapFocus($banner);
    }

    $bannerOpenButton.on("click", function (e) {
        $banner.removeClass("banner-ice--closed");
        $("body").addClass("no-scroll");
        $el.attr("aria-expanded", "true");

        if (window.CookieScript && CookieScript.instance) {
            const state = CookieScript.instance.currentState();
            const isAccepted = state?.categories.includes("functionality");

            if (isAccepted) {
                Cookies.remove("banner-ice");
            }
        }
    });

    const bannerIceclickedLink = () => {
        $banner.addClass("banner-ice--closed");
        $("body").removeClass("no-scroll");
        $el.attr("aria-expanded", "false");

        if (window.CookieScript && CookieScript.instance) {
            const state = CookieScript.instance.currentState();
            const isAccepted = state?.categories.includes("functionality");

            if (isAccepted) {
                Cookies.set("banner-ice", "closed", { expires: 1 });
            }
        }
    };

    //handles toggle 0pen/close function
    $el.on("click", function (e) {
        bannerIceclickedLink();
    });

    //Check if any of the links are clicked
    $bannerContentLinks.on("click", function (e) {
        bannerIceclickedLink();
    });
};

export default BannerIce;
